import mergeTagModalCreator from '../../../../merge-tags/helpers/merge-tag-modal-creator';
import walletTemplateModelReducer from '../../helpers/template-model-reducer';

import colorConverter from 'color-convert';
import walletTemplatePreviewModalCreator from '../../helpers/wallet-template-preview-modal-creator';

export default class AlWalletEditorController {
    constructor($scope, $injector) {
        this.scope = $scope;
        this.injector = $injector;

        this.walletTemplateId = null;
        this.cancelTrigger = null;

        this.translate = this.injector.get('$translate');
        this.usersStore = this.injector.get('Users');
        this.acl = this.injector.get('Acl');
        this.state = this.injector.get('$state');
        this.alert = this.injector.get('Alert');
        this.api = this.injector.get('$http');

        this.lastBlurInformation = null;

        this.currentActiveView = '';
        this.loading = true;
        this.submitting = false;
        this.editEnabled = false;
        this.dataChanged = false;
        this.submitEnabled = false;

        this.currentFiles = {};
        this.originalTemplate = null;
        this.model = {
            name: 'New Wallet Ticket',
            image_logo: null,
            image_background: null,
            image_thumbnail: null,
            image_icon: null,
            code_text: '',
            primary_label: '',
            primary_text: '',
            secondary_label: '',
            secondary_text: '',
            auxiliary_label: '',
            auxiliary_text: '',
            backfield_label: '',
            backfield_text: '',
            background_color: {
                red: 221,
                blue: 201,
                green: 255
            },
            fore_color: {
                red: 255,
                blue: 255,
                green: 255
            },
            label_color: {
                red: 255,
                blue: 255,
                green: 255
            }
        }
        this.originalModel = _.cloneDeep(this.model);

        this.initialColors = {
            background: '#ddc9ff',
            fore: '#ffffff',
            label: '#ffffff',
        }
        this.mediaDirectory = _.get(this.usersStore, 'state.company.media.default_directories.wallets', null);
    }

    $onInit() {
        this.cancelTrigger = () => {
            return this.cancel(true);
        }

        this._loadTemplate()
            .then(() => {
                this._checkEditEnabled();
            });

        this._checkEditEnabled();
        this._initWatchers();
    }

    handleQrCodeContentUpdate(content) {
        this.model.code_text = content;
    }

    submit(form) {
        if (!form.$valid) {
            this.alert.animatedAlert(
                this.translate.instant('general.alerts.data_invalid.title'),
                this.translate.instant('general.alerts.data_invalid.content'),
                'failed',
                {
                    showCancelButton: false,
                    confirmButtonText: this.translate.instant('general.verbs.ok')
                }
            );
            return;
        }
        this.submitting = true;

        this.api.put(`wallets/templates/${this.originalTemplate.id}`, this.model)
            .then(({data}) => {
                this._fillModelsFromApiResponseData(data.data);
                this.alert.success(
                    this.translate.instant('general.alerts.change_save_success.title'),
                    this.translate.instant('general.alerts.change_save_success.content')
                );
                this.submitting = false;

                this.onSaveSuccess({
                    template: _.cloneDeep(this.originalTemplate)
                });
            })
            .catch((e) => {
                this.submitting = false;
                this.alert.handle(e);
            })
    }

    cancel(noEventTrigger) {
        return new Promise((resolve, reject) => {
            if (!this.dataChanged) {
                if (!noEventTrigger) {
                    this.onCancel();
                }
                resolve();
                return;
            }

            this.alert.animatedAlert(
                this.translate.instant('general.alerts.ask-for-cancel-without-saving-changes.title'),
                this.translate.instant('general.alerts.ask-for-cancel-without-saving-changes.content'),
                'attention',
                {
                    confirmButtonText: this.translate.instant('general.alerts.ask-for-cancel-without-saving-changes.confirm'),
                    cancelButtonText: this.translate.instant('general.alerts.ask-for-cancel-without-saving-changes.cancel')
                }
            ).then(() => {
                if (!noEventTrigger) {
                    this.onCancel();
                }
                resolve();
            }).catch(() => {
                reject();
            });
        });
    }

    handleBlurElement(event) {
        this.lastBlurInformation = {
            element: event.target,
            cursorPosition: event.target.selectionStart
        }
    }

    triggerMergeTagPopUp(event, fieldIdToInsert, modelFieldPath) {
        let cursorPositionToInsert = (this.lastBlurInformation && this.lastBlurInformation.element.id === fieldIdToInsert) ? this.lastBlurInformation.cursorPosition : -1,
            elementToInsert = angular.element(`#${fieldIdToInsert}`);

        this.lastBlurInformation = null;

        mergeTagModalCreator(
            this.injector,
            {
                guestlistId: null,
                hideNonGuestlist: false,
                scopedGuestlists: [],
                entityPrefix: 'passbooks'
            }
        )
            .then(({placeholder}) => {
                const oldValue = _.get(this.model, modelFieldPath, '');
                let newValue = oldValue;

                if (cursorPositionToInsert === -1) {
                    newValue += placeholder;
                } else {
                    newValue = [
                        oldValue.slice(0, cursorPositionToInsert),
                        placeholder,
                        oldValue.slice(cursorPositionToInsert)
                    ].join('');
                }

                _.set(this.model, modelFieldPath, newValue);
            })
            .catch((e) => {
                console.error(e);
            })
    }

    changeCurrentActiveView(newView) {
        this.currentActiveView = newView;
    }

    handleFileSelection(imageName, file) {
        this.currentFiles[imageName] = file;
        _.set(
            this.model,
            'image_' + imageName,
            _.get(file, 'uuid', null)
        );
    }

    handleColorUpdate(colorName, color) {
        this.model[`${colorName}_color`] = {
            red: color.rgb.r,
            green: color.rgb.g,
            blue: color.rgb.b
        }
        this.initialColors[colorName] = color.hex;
    }

    triggerPreviewModal() {
        walletTemplatePreviewModalCreator(this.injector, this.model);
    }

    _initWatchers() {
        this.scope.$watch(
            () => this.model,
            () => {
                this._checkDataChanged()
            },
            true
        );
    }

    _loadTemplate() {
        return this.api.get(`wallets/templates/${this.walletTemplateId}`)
            .then(({data}) => {
                this._fillModelsFromApiResponseData(data.data);
                this.loading = false;
            })
            .catch((e) => this.alert.handle(e));
    }

    _checkEditEnabled() {
        this.editEnabled = this.acl.hasRight('passbooks::edit') && (this.originalTemplate && !this.originalTemplate.deleted_at);

        this._checkSubmitEnabled();
    }

    _checkDataChanged() {
        this.dataChanged = !_.isEqual(this.model, this.originalModel);

        this._checkSubmitEnabled();
    }

    _checkSubmitEnabled() {
        this.submitEnabled = this.editEnabled && this.dataChanged;
    }

    _fillModelsFromApiResponseData(template) {
        this.originalTemplate = template;
        this.model = walletTemplateModelReducer(this.originalTemplate);
        this.originalModel = _.cloneDeep(this.model);

        _.each(this.initialColors, (color, field) => {
            const rgbInitialValue = this.model[`${field}_color`];
            this.initialColors[field] = '#' + colorConverter.rgb
                .hex(
                    parseInt(rgbInitialValue.red),
                    parseInt(rgbInitialValue.green),
                    parseInt(rgbInitialValue.blue)
                );
        })

        _.each(['background', 'logo', 'thumbnail', 'icon'], (imageName) => {
            if (this.originalTemplate[`image_${imageName}`]) {
                this.currentFiles[imageName] = this.originalTemplate[`image_${imageName}`];
            }
        })
    }
}

AlWalletEditorController.$inject = [
    '$scope',
    '$injector'
]



// WEBPACK FOOTER //
// ./src/app/modules/wallets/templates/components/al-wallet-template-editor/controller.js